// Exports
export default {
	"limitMessage": "limitMessage_ymCEF",
	"limitMessageIcon": "limitMessageIcon_liNVq",
	"limitMessageContent": "limitMessageContent_u6KoQ",
	"limitMessageTitle": "limitMessageTitle_amSBr",
	"limitMessageText": "limitMessageText_auhOH",
	"warning": "warning_aa+LK",
	"error": "error_HMfhc"
};
